import { ILegenda } from "@deltasge/marauders-map";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import React, { FC } from "react";

export const LegendasComponent: FC<{
  qtdeEtapas: number;
  nomeEtapa: string;
  etapaAtual: number;
  etapa: number;
  legendas: ILegenda[];
  value: string;
  setValue: (value: string) => void;
}> = ({
  qtdeEtapas,
  nomeEtapa,
  etapaAtual,
  etapa,
  legendas,
  value,
  setValue,
}) => {
  return (
    <FormControl size="small">
      {qtdeEtapas > 1 && (
        <FormLabel>{`${
          qtdeEtapas == 1 ? etapaAtual : etapa + 1
        }º ${nomeEtapa}`}</FormLabel>
      )}
      <RadioGroup
        row
        value={value}
        onChange={({ target: { value } }) => setValue(value)}
        onClick={(e) => {
          const { value: currValue, checked } = e.target as EventTarget &
            HTMLInputElement;
          if (checked && value == currValue) {
            setValue("");
          }
        }}
      >
        {legendas.map((legenda) => (
          <Tooltip title={legenda.nome} key={`legenda-${etapa}-${legenda.id}`}>
            <FormControlLabel
              value={legenda.codigo}
              control={<Radio />}
              label={legenda.nomeAbrev}
            />
          </Tooltip>
        ))}
      </RadioGroup>
    </FormControl>
  );
};
